import { Quantize as QuantizeScale } from '@antv/scale';
export const Quantize = (options) => {
    return new QuantizeScale(options);
};
Quantize.props = {};
//# sourceMappingURL=quantize.js.map